import { render } from "./BlogPage1.vue?vue&type=template&id=9603bf7c&scoped=true"
import script from "./BlogPage1.vue?vue&type=script&lang=js"
export * from "./BlogPage1.vue?vue&type=script&lang=js"

import "./BlogPage1.vue?vue&type=style&index=0&id=9603bf7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9603bf7c"]])

export default __exports__